var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStatusSuccessIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1360_1365)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16ZM4.72448 7.37921C4.80256 7.41415 4.87318 7.46494 4.93222 7.52861L7.03974 9.72395L11.7073 4.86195C11.828 4.74051 11.9896 4.67331 12.1574 4.67483C12.3252 4.67635 12.4858 4.74646 12.6044 4.87007C12.7231 4.99367 12.7904 5.16088 12.7919 5.33568C12.7933 5.51048 12.7288 5.67888 12.6122 5.80461L7.49222 11.1379C7.3722 11.2629 7.20944 11.3331 7.03974 11.3331C6.87003 11.3331 6.70728 11.2629 6.58726 11.1379L4.02726 8.47128C3.96613 8.40978 3.91738 8.33622 3.88383 8.25488C3.85029 8.17355 3.83264 8.08607 3.8319 7.99755C3.83116 7.90903 3.84735 7.82124 3.87953 7.73931C3.91171 7.65738 3.95924 7.58294 4.01933 7.52035C4.07942 7.45775 4.15088 7.40825 4.22953 7.37473C4.30818 7.34121 4.39246 7.32434 4.47744 7.32511C4.56241 7.32588 4.6464 7.34427 4.72448 7.37921Z",
    fill: "#32D7BE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1360_1365"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    rx: 8,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusSuccessIcon);
export default __webpack_public_path__ + "static/media/status-success-icon.ce4357d752eef730b5fe036889625f90.svg";
export { ForwardRef as ReactComponent };